import { Cloud, Server } from "lucide-react";
import type { StreamMode } from "../lib/streamMode";

interface Props {
  value: StreamMode;
  onChange: (m: StreamMode) => void;
  /** Optional one-line caption below the slider. */
  helperText?: string;
  /** Optional title above the slider. Defaults to "Streaming". */
  title?: string;
}

export function StreamModeToggle({ value, onChange, helperText, title = "Streaming" }: Props) {
  return (
    <div className="bg-surface/40 rounded-xl p-2 space-y-1.5">
      <p className="text-[10px] font-mono uppercase tracking-[0.06em] text-text-secondary px-1">
        {title}
      </p>
      <div role="radiogroup" aria-label="Stream mode" className="grid grid-cols-2 bg-canvas rounded-lg p-1 gap-1">
        <button
          type="button"
          role="radio"
          aria-checked={value === "direct"}
          onClick={() => onChange("direct")}
          className={`flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[12px] font-ui font-medium uppercase tracking-[0.04em] transition-fast ${
            value === "direct"
              ? "bg-accent-gold text-canvas"
              : "text-text-secondary hover:text-text-primary"
          }`}
        >
          <Cloud size={12} /> Direct
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={value === "proxied"}
          onClick={() => onChange("proxied")}
          className={`flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[12px] font-ui font-medium uppercase tracking-[0.04em] transition-fast ${
            value === "proxied"
              ? "bg-accent-gold text-canvas"
              : "text-text-secondary hover:text-text-primary"
          }`}
        >
          <Server size={12} /> Proxied
        </button>
      </div>
      {helperText && (
        <p className="text-[10px] font-ui text-text-secondary px-1 leading-snug">
          {helperText}
        </p>
      )}
    </div>
  );
}
